import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const FALLBACK_SITE_URL = "https://www.antalia-pharma.com";
const LANGS = ["it", "en", "de", "nl", "pl", "ru", "ar", "es", "he", "el"];

const upsertLink = (rel, attr, attrValue, href) => {
  let el = document.querySelector(`link[rel="${rel}"][${attr}="${attrValue}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute(attr, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const SeoLinks = () => {
  const location = useLocation();
  const [siteUrl, setSiteUrl] = useState(FALLBACK_SITE_URL);

  useEffect(() => {
    api.config().then((c) => c.site_url && setSiteUrl(c.site_url.replace(/\/$/, ""))).catch(() => {});
  }, []);

  useEffect(() => {
    const path = location.pathname;
    upsertLink("canonical", "data-seo", "canonical", `${siteUrl}${path}`);
    LANGS.forEach((l) => upsertLink("alternate", "hreflang", l, `${siteUrl}${path}?lang=${l}`));
    upsertLink("alternate", "hreflang", "x-default", `${siteUrl}${path}`);
  }, [location.pathname, siteUrl]);

  return null;
};
